module.exports = __webpack_public_path__ + "img/y-157.bb5fa76f.png";